import React from 'react';

export default () => (
  <svg
    width="23"
    height="17"
    viewBox="0 0 23 17"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Page 1</title>
    <path
      d="M21.192 0L7.759 13.432 1.419 7.05 0 8.46l7.754 7.806L22.606 1.414z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/IconCheck.jsx